import i, { useMemo as l } from "react";
import { locales as k } from "../../../../../features/common/components/forms/LanguageSelector/locales.min.js";
import { useKioskLanding as f } from "../../context.js";
import { KioskButton as L } from "../KioskButton/KioskButton.js";
function b({
  langs: n,
  onChange: r
}) {
  const { lang: s, setLang: a } = f(), m = (t) => {
    a(t), r == null || r(t);
  };
  return l(() => {
    const t = new Set(n), u = Array.from(t);
    return /* @__PURE__ */ i.createElement("div", { "data-testid": "kiosk-language-selector" }, u.map((e) => {
      const o = k.find((d) => d.value === e), c = (o == null ? void 0 : o.label) ?? "unknown", p = String(c).charAt(0).toUpperCase() + String(c).slice(1);
      return /* @__PURE__ */ i.createElement(
        L,
        {
          key: e,
          type: e === s ? "primary" : "secondary",
          onClick: () => m(e)
        },
        p
      );
    }));
  }, [s, n]);
}
export {
  b as KioskLanguageSelector
};
//# sourceMappingURL=KioskLanguageSelector.js.map
